export enum Page {
  Home,
  Categories,
  Chatbot,
  Category,
  Search,
  Article,
}
